"use client";

import Image from "next/image";
import Link from "next/link";
import { Card, Col, Container, Row } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";

import "./LatestPostCard.scss";

const LatestPostCard = ({ blogs = [] }) => {

   const latestPosts = blogs.slice(0, 50);

  if (!latestPosts.length) return null;

  return (
    <section className="post-section py-5">
      <Container>
        <h5 className="mb-4 fw-bold">Latest Post</h5>

        <Row>
          {latestPosts.map((post) => (
            <Col key={post.slug} md={4} className="mb-4">
              <Link
                href={`/blog/${post.slug}`}
                className="text-decoration-none"
              >
                <Card className="post-card h-100">
                  <div className="post-image-wrapper">
                    {post.image ? (
                      <Image
                        src={post.image}
                        alt={post.title}
                        fill
                        sizes="(max-width: 768px) 100vw, 33vw"
                        className="card-img-top img-fluid"
                      />
                    ) : (
                      <div className="blog-image-placeholder">Blog</div>
                    )}
                  </div>

                   <Card.Body className="post-card-body">
                    {/* <span className="badge mb-1">
                      {post.category || "GSUS"}
                    </span> */}

                    <h5 className="fw-semibold post-card-title">
                      {post.title}
                    </h5>
                  </Card.Body>

                  <Card.Footer className="bg-white border-top-0 d-flex align-items-center justify-content-between post-card-footer">
                    <div className="d-flex align-items-center gap-2 post-author">
                      <FaUserCircle />
                      <span>{post.author || "Admin"}</span>
                    </div>

                    {post.date && <span>{post.date}</span>}
                  </Card.Footer>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default LatestPostCard;